import * as React from "react"
import { SVGProps } from "react"

const CopyCross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 6H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1h-2v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1V6Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 4H9a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1ZM9 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H9Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.293 6.293a1 1 0 0 1 1.414 0L14 8.586l2.293-2.293a1 1 0 1 1 1.414 1.414L15.414 10l2.293 2.293a1 1 0 0 1-1.414 1.414L14 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L12.586 10l-2.293-2.293a1 1 0 0 1 0-1.414Z"
      fill="#fff"
    />
  </svg>
)

export default CopyCross
